import { render, staticRenderFns } from "./allResources.vue?vue&type=template&id=0dba7dfc&scoped=true&"
import script from "./allResources.vue?vue&type=script&lang=js&"
export * from "./allResources.vue?vue&type=script&lang=js&"
import style0 from "./allResources.vue?vue&type=style&index=0&id=0dba7dfc&lang=scss&scoped=true&"
import style1 from "./allResources.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba7dfc",
  null
  
)

export default component.exports